import React, { useEffect, useContext } from 'react';
import { useThree } from '@react-three/fiber';
import { ModelManager } from '../model/ModelManager';
import { useProductModelStore } from '../store/productModelStore';
import { ConfigurationStateContext } from '../store/configurationState/ConfigurationStateProvider';
import LoadingStateComponent from './functional-components/LoadingStateComponent';
import { useViewerStateStore } from '../store/viewerStateStore';
import { ViewerModeEnum } from '../store/viewerState/ViewerMode/ViewerMode';
import StoreysSideBySideComponent from './functional-components/StoreysSideBySideComponent';
import { useModelPropertiesStore } from '../store/modelPropertiesStore/modelPropertiesStore';

const ModelManagerComponent = () => {
    const { scene } = useThree();
    const { products, materials, setRootProductLoadingState } = useProductModelStore();
    const { viewerMode, isDebugMode } = useViewerStateStore();
    const { rotationOffset } = useModelPropertiesStore();
    
    const { configurationState } = useContext(ConfigurationStateContext);

    useEffect(() => {
        const modelManager = ModelManager.getInstance();
        modelManager.init(scene); 
        
        return () => {
            // Cleanup if needed, but ModelManager is singleton currently
        };
    }, [scene]);

    useEffect(() => {
        const modelManager = ModelManager.getInstance();

        if (products.length > 0 ) {

            modelManager.update(products,configurationState.visualizerApiUrl.toString(), setRootProductLoadingState);
        }
        
    }, [products]);

    useEffect(() => {
        const modelManager = ModelManager.getInstance();
        if (materials.length > 0) {
            modelManager.updateMaterials(materials, viewerMode?.materialSet, isDebugMode, viewerMode?.stageType);
        }

    }, [materials, viewerMode, isDebugMode]);


    useEffect(() => {
        const modelManager = ModelManager.getInstance();
        modelManager.onRotationOffsetChanged(rotationOffset);
    }, [rotationOffset]);

    return <>
        <LoadingStateComponent />
        { viewerMode?.modeEnum == ViewerModeEnum.ApartmentSelect2d && <StoreysSideBySideComponent />}
    </>;
};

export default ModelManagerComponent;
